import {
    SETUP,
    FETCH_CHAINS,
    FETCH_CHAIN,
    SAVE_CHAIN,
    DELETE_CHAIN,
} from '../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SETUP:
            return action.payload.businessApp.chains;
        case FETCH_CHAINS:
            return action.payload;
        case FETCH_CHAIN:
            return state.map(chain => chain.id === (action.payload[0] || {}).id ? { ...chain, ...action.payload[0] } : chain);
        case SAVE_CHAIN:
            if (action.meta && action.meta.chainId) {
                return state.map(chain => chain.id === action.meta.chainId ? action.payload : chain);
            }
            return state.concat(action.payload);
        case DELETE_CHAIN:
            return state.filter(chain => chain.id !== action.meta.chainId);
        default:
            return state;
    }
};
